export type NavItemType = 'navigation' | 'divider';

export interface NavItem {
  icon: string;
  label: string;
  route: string;
  type: NavItemType;
  submenu?: NavItem[];
  openByDefault?: boolean;
}

export interface PartnerSettings {
  wp_assets_slug?: string;
  pd_view_sr_reports?: boolean;
  pd_view_sr_webhooks: boolean;
  reporting_logo_overwrite?: string | null;
}

export interface PartnerTheme {
  background: string;
  buttonHoverBackground: string;
  freeTrialBg: string;
  homeLeft: string;
  homeRight: string;
  inputBackground: string;
  primary: string;
  primaryButtonTextColor: string;
  primaryTextColor: string;
  secondary: string;
  secondaryButtonTextColor: string;
  secondarytextcolor: string;
  squareCorners: '0' | '1'; // boolean 0 | 1 but getting as string from API
  subheaderBackground: string;
  subheaderTextColor: string;
}

export interface Partner {
  domain?: string | null;
  extra_styles: boolean;
  home_link: string;
  id: number;
  is_default: boolean;
  logo: string | null;
  name: string;
  partner_id: number;
  settings: PartnerSettings;
  slug: string;
  theme: PartnerTheme;
}

export interface Dictionary {
  navigation: NavItem[] | [];
  partners: Partner[] | null;
}

export interface AppStateType {
  maintenanceMode: boolean;
  dictionary: Dictionary;
  loadings: {
    dictionary: boolean;
    switchPartner: boolean;
  };
}

export const APP = 'app';
export type APP = typeof APP;
